
import store from '@/store/store.js'
import { stopBackgroundActivity,addStatusBarInHtml } from '@/modules/helper'
import DeviceInfo from '@/modules/util/deviceInfo'
// import * as AppReporting from '@/modules/appReporting/index'

export const getCountryCode = () => {
  return new Promise((resolve, reject) => {
    navigator.globalization.getLocaleName(locale => {
      if (locale && locale.includes('-')) {
        resolve(locale.split('-'))
      } else {
        resolve(locale)
      }
    }, error => {
      reject(error)
    })
  })
}

export const onDeviceReady = () => {
  return new Promise((resolve, reject) => {
     document.addEventListener("pause", onEndCallKeyDown, false)
    document.addEventListener('deviceready', () => {
      if (Keyboard) {
        Keyboard.shrinkView(true)
      }
    document.addEventListener("resume", () => {
        if (Keyboard) {
          Keyboard.hide()
        }
        }, false)
      resolve()
    }, false)
    //AppReporting.RegisterAppSessionStart()
    console.log('onDeviceReady ')
  })
}

export const handleStatusBar = () => {
  if (DeviceInfo.isIOS) {
    let context = document.html || document.getElementsByTagName('html')[0]
    context.classList.add('with-statusbar')
  }
}

export const manageInputOnKeyboardOpen = () => {
  if (DeviceInfo.isIOS) {
    if (document.activeElement.nodeName === 'INPUT' || document.activeElement.nodeName === 'TEXTAREA') {
      document.activeElement.scrollIntoView()
    }
  }
}

function onEndCallKeyDown() {
  stopBackgroundActivity(store)
}
export const onDevicePause = () => {
  return new Promise((resolve, reject) => {
    document.addEventListener('pause', () => {
      resolve()
    }, false)
  })
}

export const onDeviceResume = () => {
  return new Promise((resolve, reject) => {
    document.addEventListener('resume', () => {
      resolve()
    }, false)
  })
}

export const isAndroid = () => window.device.platform.toLowerCase() === 'android'

export const isIOS = () => window.device.platform.toLowerCase() === 'ios'

export const getDeviceModel = () => window.device ? window.device.model : 'None'

export const getDevicePlatform = () => window.device ? window.device.platform : 'WebApp'

export const getDeviceVersion = () => window.device ? window.device.version : 'None'

export const isDisconnected = () => navigator.connection.type === window.Connection.NONE

export const isConnected = () => !isDisconnected()



// WEBPACK FOOTER //
// ./src/modules/phonegap/index.js